import { AttachFile } from "@mui/icons-material"
import React from "react"
import { Col, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { currencyCode, employmentType, Job, salaryUnit } from "../../contents/job/Job"

export const JobItemLarge: React.FC<{job: Job}> = ({job}) => {
  const { t } = useTranslation("jobs")
  const wageRate = salaryUnit[job.salary.unit]
  const currency = currencyCode[job.salary.currencyCode]

  const wage = `${wageRate}${job.salary.min}${currency}以上`
  const type = employmentType[job.employmentType]
  const tags = [type, wage, ...job.tags.map(tag => t(tag))]

  return (
    <Row>
      <Col className="animation-slide-in text-start mb-4" style={{opacity: job.active ? "1" : "0.5"}}>
        <div className="h-100 bg-light rounded px-4 py-5 text-start position-relative">
          <AttachFile
            fontSize="large"
            className="position-absolute mt-n5 ms-n3 text-start"
            style={{opacity: "0.05", top: '-0.5rem', left: '-0.5rem'}}
          />
          <div className="mx-md-5 mt-2">
            <div className="text-center mb-5">
              <div className="mb-4">
                <h2 className="mb-0">{t(job.title)}</h2>
                {job.titleEng !== "" && <small>- {t(job.titleEng)} -</small>}
              </div>
            </div>
            <div className="mb-4 d-flex justify-content-center flex-wrap">
              {tags.map((i, key) => <small key={key} className="bg-dark text-white px-2 mb-2 mx-1 rounded">{i}</small>)}
            </div>
            <h5 className="text-start"><strong>必須条件</strong></h5>
            <p className="ms-3 mb-4 text-start">{t(job.skill.required)}</p>
            <h5 className="text-start"><strong>歓迎条件</strong></h5>
            <p className="ms-3 mb-2 text-start">{t(job.skill.optional)}</p>
            <p className="ms-3 mb-4 text-start">
              以下の技術が使える方<br />
              {job.skill.technologies.join(", ")}
            </p>
            <h5 className="text-start"><strong>業務内容</strong></h5>
            <div className="ms-3 mb-4 text-start">
              <ul>
                {job.works.map(i => <li key={i}>{t(i)}</li>)}
              </ul>
              <div>※会社の状況によっては記載された内容と異なる業務内容となる場合があります。</div>
            </div>
            <h5 className="text-start"><strong>給与</strong></h5>
            <p className="ms-3 mb-4 text-start">
              {wageRate}{job.salary.min} 〜 {job.salary.max}{currency}
            </p>
            <h5 className="text-start"><strong>雇用形態</strong></h5>
            <p className="ms-3 mb-4 text-start">
              {type}
            </p>

            <h5 className="text-start"><strong>備考</strong></h5>
            <p className="ms-3 mb-0 text-start">{t(job.description)}</p>
          </div>
        </div>
      </Col>
    </Row>
  )
}
